import { useEffect, useRef, useState } from "react";

import i18next from "i18next";

import { defaultCountries } from "../../../config";

import { getCountries } from "../../../protocols";

import { DropdownComponent, InputComponent } from "../../ui";
import { CountryFlag, CountryItem, CountryLabel, SelectedCountryFlag, Wrapper } from "./style";

const BookingCitizenshipSelectComponent = ({
  touched,
  error,
  success,
  onChange,
  onBlur,
  clearFieldError,
  initialValue,
}) => {
  const { language, t } = i18next;
  const [value, setValue] = useState("");
  const [citizenship, setCitizenship] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [countries, setCountries] = useState(defaultCountries);
  const hasInitialized = useRef(false);

  const handleOnSelect = useRef(country => {
    setCitizenship(country);
    setValue(country.country[language]);
    onChange(country.code);
    setShowDropdown(false);
  });

  const handleChangeInput = newValue => {
    setValue(newValue);

    if (newValue.trim().length === 0) {
      setCitizenship(null);
      onChange("");

      setCountries(defaultCountries);
      setShowDropdown(true);
      return;
    }

    setShowDropdown(true);

    if (citizenship && !citizenship.country[language].toLowerCase().includes(newValue.toLowerCase())) {
      setCitizenship(null);
      onChange("");
    }

    if (newValue.length > 1) {
      getCountries(newValue, language).then(response => {
        const newCountries = response?.data?.data || defaultCountries;
        setCountries(newCountries);

        if (newCountries.length > 0) {
          setShowDropdown(true);
        }
      });
    } else {
      setCountries(defaultCountries);
    }
  };

  const handleInputFocus = () => {
    clearFieldError();
    setShowDropdown(true);
  };

  const handleInputClick = () => {
    setShowDropdown(true);
  };

  const renderCountryItems = () => {
    return countries.map((country, index) => {
      return (
        <CountryItem key={index} onClick={() => handleOnSelect.current(country)}>
          <CountryFlag backgroundImage={`/flags/${country.code}.png`} />
          <CountryLabel>{country.country[language]}</CountryLabel>
        </CountryItem>
      );
    });
  };

  useEffect(() => {
    if (initialValue && !citizenship && !hasInitialized.current) {
      const country = countries.find(cntr => cntr.code === initialValue.toUpperCase());

      if (!!country) {
        handleOnSelect.current(country);
      }
      hasInitialized.current = true;
    }
  }, [initialValue, countries, citizenship]);

  return (
    <Wrapper>
      <InputComponent
        value={value}
        onChange={handleChangeInput}
        label={t("citizenship")}
        placeholder={t("citizenship")}
        touched={touched}
        error={!showDropdown ? error : null}
        onBlur={onBlur}
        onClick={handleInputClick}
        onFocus={handleInputFocus}
        success={success}
        required
      />

      {citizenship && <SelectedCountryFlag backgroundImage={`/flags/${citizenship.code}.png`} />}

      {showDropdown && (
        <DropdownComponent show={showDropdown} onClickOutside={() => setShowDropdown(false)} noPadding>
          {renderCountryItems()}
        </DropdownComponent>
      )}
    </Wrapper>
  );
};

export default BookingCitizenshipSelectComponent;
